import { Download } from 'lucide-react';
import React from 'react';
import type { ExamBooklet } from '../../../types/practice-exam';

/**
 * Kâğıtta çözmek isteyen öğrenci için kitapçık PDF'leri. Dosya yeni sekmede açılır, indirme ve yazdırma oradan yapılır: CDN başka
 * alan adında olduğu için tarayıcı `download` özniteliğini yok sayar.
 */
export default function ExamPdfLinks({ booklets = [], levelType }: { booklets?: ExamBooklet[]; levelType?: string | null }) {
  const pdfs = booklets.filter((booklet) => booklet.pdfUrl);
  if (!pdfs.length) return null;

  return (
    <details>
      <summary className="inline-flex cursor-pointer list-none items-center gap-1.5 rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 [&::-webkit-details-marker]:hidden">
        <Download size={15} />
        PDF indir / yazdır
      </summary>
      <div className="mt-2 grid grid-cols-2 gap-1.5">
        {pdfs.map((booklet) => (
          <a
            key={booklet.key}
            href={booklet.pdfUrl}
            target="_blank"
            rel="noreferrer"
            className="rounded-md border border-gray-200 bg-white px-2 py-1.5 text-center text-xs font-medium text-blue-700 hover:bg-blue-50"
          >
            {booklet.label}
          </a>
        ))}
      </div>
      <p className="mt-2 text-xs leading-5 text-gray-500">
        Kâğıtta çözdükten sonra cevapları soru ekranındaki "Toplu ekle (optik)" ile girebilirsiniz.
        {/* Şık harfi baskı hataları MEBİ YKS kitaplarında bulundu */}
        {levelType !== 'lgs' && ' Kitapçık özgün baskıdır, birkaç soruda şık harfi baskı hatası vardır; doğru cevabı etkilemez.'}
      </p>
    </details>
  );
}
